var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hackathonLayout',{scopedSlots:_vm._u([{key:"right-side",fn:function(){return [(_vm.isInLobby)?_c('div',{staticClass:"lobby"},[_vm._v("點選私訊的對象")]):_c('router-view')]},proxy:true}])},[[_c('Messagebar')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }